const ROUTE_THROUGH_PARAMS = [
  "li_fat_id", // LinkedIn tracking
  "gclid", // Google tracking
];

export const forwardUrlToApp = (baseUrl: string, params?: object): string => {
  if (!baseUrl) {
    return baseUrl;
  }

  const existingParams = new URLSearchParams(window.location.search);
  const url = new URL(baseUrl);

  ROUTE_THROUGH_PARAMS.forEach((param) => {
    if (existingParams.has(param)) {
      url.searchParams.set(param, existingParams.get(param) ?? "");
    }
  });

  // Do this last, so the given ones override and take precence
  if (params) {
    Object.keys(params).forEach((key) => {
      if (params[key] !== undefined) {
        url.searchParams.set(key, params[key]);
      }
    });
  }

  return url.toString();
};

export const isPreview = () => {
  const params = new URLSearchParams(window.location.search);
  return params.get("preview") === "true";
};



// WEBPACK FOOTER //
// ./src/utils/Utils.ts